<template>
  <div class="step__blocks">
    <div class="s-block">
      <div class="s-text">
        <div v-if="item.UF_DESCR_TITLE" class="s-text__description">{{ item.UF_DESCR_TITLE }}:</div>
        <div class="s-text__list" v-html="description"></div>
      </div>
      <div class="s-range" :class="{'disabled':disabledDoor}">
        <div class="s-inputs__item-title">{{ item.UF_SIZE_TITLE }}:</div>
        <div class="s-range__slider">
          <div v-show="item.UF_BOTTOM_LIMIT && item.UF_TOP_LIMIT" class="s-range__left">
            <Veeno ref="veenoDoor" :connect="'lower'" :step="1" :handles="[door]" :range="rangeDoor" v-model="door" @change="sliderChange('door')"/>
            <div class="s-range__text">
              <div v-show="this.item.UF_BOTTOM_LIMIT" class="s-range__text-min">{{ Number(item.UF_BOTTOM_LIMIT) }} мм
              </div>
              <div v-show="this.item.UF_STANDART" class="s-range__text-standart" @click="reset('door')">Стандартное
                                                                                                        значение
              </div>
              <div v-show="this.item.UF_TOP_LIMIT" class="s-range__text-max">{{ Number(item.UF_TOP_LIMIT) }} мм
              </div>
            </div>
          </div>
          <div class="s-inputs">
            <div class="default-input">
              <input class="default-input__input" type="number" @change="inputDoor" v-model="doorInput">
              <label class="default-input__label">мм</label>
            </div>
          </div>
        </div>
      </div>

      <div class="s-range" :class="{'disabled':disabledPanel}">
        <div class="s-inputs__item-title">{{ item.UF_SIZE_TITLE_2 }}:</div>
        <div class="s-range__slider">
          <div v-show="item.UF_BOTTOM_LIMIT_2 && item.UF_TOP_LIMIT_2" class="s-range__left">
            <Veeno ref="veenoPanel" :connect="'lower'" :step="1" :handles="[panel]" :range="rangePanel" v-model="panel" @change="sliderChange('panel')"/>
            <div class="s-range__text">
              <div v-show="this.item.UF_BOTTOM_LIMIT_2" class="s-range__text-min">{{ Number(item.UF_BOTTOM_LIMIT_2) }}
                                                                                  мм
              </div>
              <div v-show="this.item.UF_STANDART_2" class="s-range__text-standart" @click="reset('panel')">Стандартное
                                                                                                           значение
              </div>
              <div v-show="this.item.UF_TOP_LIMIT_2" class="s-range__text-max">{{ Number(item.UF_TOP_LIMIT_2) }} мм
              </div>
            </div>
          </div>
          <div class="s-inputs">
            <div class="default-input">
              <input class="default-input__input" type="number" @change="inputPanel" v-model="panelInput">
              <label class="default-input__label">мм</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="s-img">
      <img :src="item.PICTURE.src" alt="Изображение" loading="lazy">
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import Veeno                  from "veeno";

export default {
  name       : "TwoSizesRangeStep",
  props      : ["number", "item", "parent", "template", "description"],
  components : {
    Veeno
  },
  data()
  {
    return {
      door       : 0,
      doorInput  : 0,
      panel      : 0,
      panelInput : 0,
      limits     : {
        door  : {
          bottom : 0,
          top    : 0
        },
        panel : {
          bottom : 0,
          top    : 0
        }
      },
      rangeDoor  : {
        "min" : Number(this.item.UF_BOTTOM_LIMIT) > 0 ? Number(this.item.UF_BOTTOM_LIMIT) : 0,
        "max" : Number(this.item.UF_TOP_LIMIT) > 0 ? Number(this.item.UF_TOP_LIMIT) : 1
      },
      rangePanel : {
        "min" : Number(this.item.UF_BOTTOM_LIMIT_2) > 0 ? Number(this.item.UF_BOTTOM_LIMIT_2) : 0,
        "max" : Number(this.item.UF_TOP_LIMIT_2) > 0 ? Number(this.item.UF_TOP_LIMIT_2) : 1
      }
    };
  },
  computed : {
    ...mapState([
      "moduleConfigurator"
    ]),
    disabledDoor()
    {
      return this.moduleConfigurator.changeSizes.door > 0 && this.item.UF_DOOR === "1";
    },
    disabledPanel()
    {
      return this.moduleConfigurator.changeSizes.panel > 0 && this.item.UF_WIDTH === "1";
    }
  },
  watch    : {
    "$store.state.moduleConfigurator.changeSizes.door"()
    {
      if(this.item.UF_DOOR === "1")
      {
        if(this.moduleConfigurator.changeSizes.door > 0)
        {
          this.moduleConfigurator.lastChanges.door = parseInt(this.door);
          this.door                                = parseInt(this.moduleConfigurator.changeSizes.door);
        }
        if(this.moduleConfigurator.changeSizes.door === 0 && this.moduleConfigurator.lastChanges.door > 0)
        {
          this.door = parseInt(this.moduleConfigurator.lastChanges.door);
        }
        this.setSelect();
        if(this.moduleConfigurator.steps[this.number - 2]["showNext"] === true)
        {
          this.moduleConfigurator.steps[this.number - 1]["showNext"] = true;
        }
      }
    },
    "$store.state.moduleConfigurator.changeSizes.panel"()
    {
      if(this.item.UF_WIDTH === "1")
      {
        if(this.moduleConfigurator.changeSizes.panel > 0)
        {
          this.moduleConfigurator.lastChanges.panel = parseInt(this.panel);
          this.panel                                = parseInt(this.moduleConfigurator.changeSizes.panel);
        }
        if(this.moduleConfigurator.changeSizes.panel === 0 && this.moduleConfigurator.lastChanges.panel > 0)
        {
          this.panel = parseInt(this.moduleConfigurator.lastChanges.panel);
        }
        this.setSelect();
        if(this.moduleConfigurator.steps[this.number - 2]["showNext"] === true)
        {
          this.moduleConfigurator.steps[this.number - 1]["showNext"] = true;
        }
      }
    },
    "door"()
    {
      this.doorInput = Math.round(this.door);
      // this.setSelect();
    },
    "panel"()
    {
      this.panelInput = Math.round(this.panel);
      // this.setSelect();
    }
  },
  methods  : {
    ...mapActions([
      "SET_SELECT", "SET_DOOR", "SET_PANEL"
    ]),
    setInStorage()
    {
      localStorage["doorPanelInfo"] = JSON.stringify(
          {
            ["step" + this.number] :
                {
                  limits : this.limits,
                  panel  : this.panel,
                  door   : this.door
                }
          });
    },
    reset( str )
    {
      if((this.moduleConfigurator.changeSizes.panel > 0 && this.item.UF_WIDTH === "1") ||
         (this.moduleConfigurator.changeSizes.door > 0 && this.item.UF_DOOR === "1"))
      {
        return;
      }
      let slider   = str === "door" ? this.$refs.veenoDoor : this.$refs.veenoPanel;
      let standart = str === "door" ? this.item.UF_STANDART : this.item.UF_STANDART_2;
      slider.$el.noUiSlider.set(Number(standart));
      if(str === "door")
      {
        this.doorInput = Math.round(this.door);
      }
      else
      {
        this.panelInput = Math.round(this.panel);
      }
      this.setSelect();
    },
    sliderChange( str )
    {
      if(str === "door" && this.moduleConfigurator.changeSizes.door > 0 && this.item.UF_DOOR === "1")
      {
        this.doorInput = Math.round(this.door);
        this.$refs.veenoDoor.$el.noUiSlider.set(this.doorInput);
      }
      else if(str === "panel" && this.moduleConfigurator.changeSizes.panel > 0 && this.item.UF_WIDTH === "1")
      {
        this.panelInput = Math.round(this.panel);
        this.$refs.veenoPanel.$el.noUiSlider.set(this.panelInput);
      }
      if(parseInt(this.item.UF_CHANGE_DOOR) > 0)
      {
        this.SET_DOOR(parseInt(this.doorInput) - parseInt(this.item.UF_CHANGE_DOOR));
      }
      else if(parseInt(this.item.UF_CHANGE_DOOR) === 0)
      {
        this.SET_DOOR(0);
      }
      if(parseInt(this.item.UF_CHANGE_PANEL) > 0)
      {
        this.SET_PANEL(this.panelInput - parseInt(this.item.UF_CHANGE_PANEL));
      }
      else if(parseInt(this.item.UF_CHANGE_PANEL) === 0)
      {
        this.SET_PANEL(0);
      }
      this.setSelect();
    },
    doorLimits()
    {
      if(!this.item.UF_LIMIT_CHANGE || !this.item.UF_LIMIT_VALUE_2)
      {
        return;
      }
      if(this.door > this.item.UF_LIMIT_VALUE_2)
      {
        this.limits.panel.top    = this.item.UF_TOP_LIMIT_2_V2;
        this.limits.panel.bottom = this.item.UF_BOTTOM_LIMIT_2_V2;
      }
      else
      {
        this.limits.panel.top    = this.item.UF_TOP_LIMIT_2;
        this.limits.panel.bottom = this.item.UF_BOTTOM_LIMIT_2;
      }
    },
    panelLimits()
    {
      if(!this.item.UF_LIMIT_CHANGE || !this.item.UF_LIMIT_VALUE)
      {
        return;
      }
      if(this.panel > this.item.UF_LIMIT_VALUE)
      {
        this.limits.door.top    = this.item.UF_TOP_LIMIT_V2;
        this.limits.door.bottom = this.item.UF_BOTTOM_LIMIT_V2;
      }
      else
      {
        this.limits.door.top    = this.item.UF_TOP_LIMIT;
        this.limits.door.bottom = this.item.UF_BOTTOM_LIMIT;
      }
    },
    inputDoor()
    {
      this.doorInput = Number(this.doorInput);
      if(this.moduleConfigurator.changeSizes.door > 0 && this.item.UF_DOOR === "1")
      {
        this.doorInput = parseInt(this.moduleConfigurator.changeSizes.door);
        return;
      }
      if(parseInt(this.doorInput) > parseInt(this.limits.door.top))
      {
        window.toast.error("Максимальное значение: " + this.limits.door.top);
      }
      if(parseInt(this.doorInput) < parseInt(this.limits.door.bottom))
      {
        window.toast.error("Минимальное значение: " + this.limits.door.bottom);
      }

      this.checkDoor();
      this.doorLimits();
      this.checkPanel();
      this.setSelect();

      if(parseInt(this.item.UF_CHANGE_DOOR) > 0)
      {
        this.SET_DOOR(parseInt(this.doorInput) - parseInt(this.item.UF_CHANGE_DOOR));
      }
      else if(parseInt(this.item.UF_CHANGE_DOOR) === 0)
      {
        this.SET_DOOR(0);
      }
      this.door = this.doorInput;
      this.$refs.veenoDoor.$el.noUiSlider.set(this.door);
    },
    inputPanel()
    {
      this.panelInput = Number(this.panelInput);
      if(this.moduleConfigurator.changeSizes.panel > 0 && this.item.UF_WIDTH === "1")
      {
        this.panelInput = parseInt(this.moduleConfigurator.changeSizes.panel);
        return;
      }

      if(parseInt(this.panelInput) > parseInt(this.limits.panel.top))
      {
        window.toast.error("Максимальное значение: " + this.limits.panel.top);
      }
      if(parseInt(this.panelInput) < parseInt(this.limits.panel.bottom))
      {
        window.toast.error("Минимальное значение: " + this.limits.panel.bottom);
      }

      this.checkPanel();
      this.panelLimits();
      this.checkDoor();
      this.setSelect();

      if(parseInt(this.item.UF_CHANGE_PANEL) > 0)
      {
        this.SET_PANEL(this.panelInput - parseInt(this.item.UF_CHANGE_PANEL));
      }
      else if(parseInt(this.item.UF_CHANGE_PANEL) === 0)
      {
        this.SET_PANEL(0);
      }
      this.panel = this.panelInput;
      this.$refs.veenoPanel.$el.noUiSlider.set(this.panel);
    },
    setSelect()
    {
      this.SET_SELECT({
        index : parseInt(this.number) - 1,
        name  : parseInt(this.doorInput) + " мм X " + parseInt(this.panelInput) + " мм",
        id    : this.item["ID"]
      });
      if(this.moduleConfigurator.steps[this.number - 2]["showNext"] === true)
      {
        this.moduleConfigurator.steps[this.number - 1]["showNext"] = true;
      }
    },
    checkDoor()
    {
      this.doorInput = parseInt(this.doorInput) > parseInt(this.limits.door.top) ?
          parseInt(this.limits.door.top) : parseInt(this.doorInput) < parseInt(this.limits.door.bottom) ?
              parseInt(this.limits.door.bottom) : parseInt(this.doorInput);
      this.setInStorage();
    },
    checkPanel()
    {
      this.panelInput = parseInt(this.panelInput) > parseInt(this.limits.panel.top) ?
          parseInt(this.limits.panel.top) : parseInt(this.panelInput) < parseInt(this.limits.panel.bottom) ?
              parseInt(this.limits.panel.bottom) : parseInt(this.panelInput);
      this.setInStorage();
    }

  },
  created()
  {
    let doorPanelInfo = localStorage["doorPanelInfo"] ? JSON.parse(localStorage["doorPanelInfo"]) : false;
    if(localStorage["doorPanelInfo"] && doorPanelInfo["step" + this.number])
    {
      this.limits = doorPanelInfo["step" + this.number].limits;
      this.door   = doorPanelInfo["step" + this.number].door;
      this.panel  = doorPanelInfo["step" + this.number].panel;
    }
    else
    {
      this.limits.door.top     = this.item.UF_TOP_LIMIT;
      this.limits.door.bottom  = this.item.UF_BOTTOM_LIMIT;
      this.limits.panel.top    = this.item.UF_TOP_LIMIT_2;
      this.limits.panel.bottom = this.item.UF_BOTTOM_LIMIT_2;
      if((this.item.UF_DOOR !== "1" && this.item.UF_WIDTH !== "1") ||
         (!this.moduleConfigurator.changeSizes.door && !this.moduleConfigurator.changeSizes.panel))
      {
        this.door  = parseInt(this.item.UF_STANDART);
        this.panel = parseInt(this.item.UF_STANDART_2);
      }
      if(this.moduleConfigurator.changeSizes.door > 0 && this.item.UF_DOOR === "1")
      {
        this.door = parseInt(this.moduleConfigurator.changeSizes.door);
      }
      if(this.moduleConfigurator.changeSizes.panel > 0 && this.item.UF_WIDTH === "1")
      {
        this.panel = parseInt(this.moduleConfigurator.changeSizes.panel);
      }
    }
    // if(!this.moduleConfigurator.steps[this.number - 1]["showNext"])
    // {
    //   this.setSelect();
    // }

    if(Number(this.item.UF_CHANGE_DOOR) > 0)
    {
      this.SET_DOOR(this.door - parseInt(this.item.UF_CHANGE_DOOR));
    }
    else if(Number(this.item.UF_CHANGE_DOOR) === 0)
    {
      this.SET_DOOR(0);
    }

    if(Number(this.item.UF_CHANGE_PANEL) > 0)
    {
      this.SET_PANEL(this.panel - parseInt(this.item.UF_CHANGE_PANEL));
    }
    else if(Number(this.item.UF_CHANGE_PANEL) === 0)
    {
      this.SET_PANEL(0);
    }
    this.panelInput = this.panel;
    this.doorInput = this.door;
    this.setSelect();

  }

};
</script>

<style scoped>

</style>